import { render, staticRenderFns } from "./Sentence.vue?vue&type=template&id=3e133691&scoped=true"
import script from "./Sentence.vue?vue&type=script&lang=js"
export * from "./Sentence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e133691",
  null
  
)

export default component.exports